import { OperationsDashboardPage } from '@/components/dashboard/operations-dashboard-page'

export function OperationsDashboard() {
  return <OperationsDashboardPage />
}
